import {SplitPageLayout} from '@primer/react'
import {OverviewMergeBox} from '../components/overview/mergebox/OverviewMergeBox'
import {Description} from '../components/overview/Description'
import {EarlyDevelopmentBanner} from '../components/overview/EarlyDevelopmentBanner'
import {CopilotReviewSummary} from '../components/overview/CopilotReviewSummary'
import {ChangeSummary} from '../components/overview/ChangeSummary'
import {Findings} from '../components/overview/Findings'
import {StickySidebar} from '@github-ui/sticky-sidebar'
import {MINI_HEADER_HEIGHT} from '../helpers/constants'
import {useIsDockedPanelCompact, useIsDockedPanelOpen} from '../contexts/DockedPanelContext'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {SIDEBAR_WITH_PANEL_BREAKPOINT, useMinWidth} from '../helpers/measure-viewport'
import styles from './Overview.module.css'
import {ForYouSection} from '../components/overview/for-you/ForYouSection'
import {OverviewInfoContent} from '../components/overview/OverviewInfoContent'
import {clsx} from 'clsx'
import {useId} from 'react'
import {useIsFeatureStateEnabled} from '../hooks/use-feature-state'

export function OverviewEntrypoint() {
  return <OverviewComponent />
}

function OverviewComponent() {
  const isDockedPanelOpen = useIsDockedPanelOpen()
  const isCompact = useIsDockedPanelCompact()
  const hasRoomForBoth = useMinWidth(SIDEBAR_WITH_PANEL_BREAKPOINT)
  const showOverviewSidebar = !isDockedPanelOpen || isCompact || hasRoomForBoth
  const showUpdatedHeader = isFeatureEnabled('updated_pull_request_header')
  const findingsFeatureEnabled = useIsFeatureStateEnabled('findings')
  const isFindingsEnabled = isFeatureEnabled('prs_overview_findings') && findingsFeatureEnabled
  const isEarlyDevelopmentBannerEnabled = isFeatureEnabled('overview_early_development_banner')

  const sidebarLabelId = useId()

  return (
    <div className={clsx('width-full', styles.layout)} data-side-panel-open={isDockedPanelOpen && !isCompact}>
      <SplitPageLayout className={styles.wrapper}>
        <SplitPageLayout.Content as="div" padding="none" className={styles.content}>
          <div className="d-flex gap-4 flex-column">
            {isEarlyDevelopmentBannerEnabled && <EarlyDevelopmentBanner />}
            <CopilotReviewSummary />
            <Description />
            <ForYouSection />
            <ChangeSummary />
            {isFindingsEnabled && <Findings />}
            <OverviewMergeBox />
          </div>
        </SplitPageLayout.Content>
        {showOverviewSidebar && (
          <SplitPageLayout.Pane
            aria-labelledby={sidebarLabelId}
            position="end"
            divider="none"
            padding="none"
            width="large"
            sticky={false}
            className={styles.panel}
          >
            <h3 className="sr-only" id={sidebarLabelId}>
              Status and details
            </h3>

            <StickySidebar topOffset={showUpdatedHeader ? MINI_HEADER_HEIGHT : 0} className={styles.sidebar}>
              <OverviewInfoContent />
            </StickySidebar>
          </SplitPageLayout.Pane>
        )}
      </SplitPageLayout>
    </div>
  )
}
